import { gql } from '@/__generated__';

const GET_DEVICE_MAIN_METRIC = gql(`#graphql
  query HomeAmaru_GetDeviceMainMetric($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      profile {
        id
        name
      }
      mainMetric {
        metricField
        unit
        lastPoint
      }
    }
  }
`);

export default GET_DEVICE_MAIN_METRIC;
